<div class="flex min-h-screen flex-col bg-[#f7f7f7]">
  <app-header></app-header>

  <main id="main-content" tabindex="-1" class="flex flex-1 flex-col outline-none">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
